import dataAxios from '../../../../modules/auth/core/dataAxios'
import { PersonType } from '../models/personType'

export const getPersonTypes = async (page: number = 0, pageSize: number = 10) => {
  const response = await dataAxios.get(`/person-types`, {
    params: {
      page,
      pageSize,
    },
  })
  return response.data
}

export const getPersonType = async (id: string) => {
  const response = await dataAxios.get(`/person-types/${id}`)
  return response.data
}

export const createPersonType = async (personType: PersonType) => {
  const { _id: _omitId, ...body } = personType
  const response = await dataAxios.post(`/person-types`, body)
  return response.data
}

export const updatePersonType = async (id: string, personType: PersonType) => {
  const { _id: _omitId, ...body } = personType
  const response = await dataAxios.patch(`/person-types/${id}`, body)
  return response.data
}

export const deletePersonType = async (id: string) => {
  const response = await dataAxios.delete(`/person-types/${id}`)
  return response.data
}
